<!-- @format -->

<section
  id="pdp-selector-attributes"
  class="selector-attributes-container"
  [ngClass]="{ 'is-config-variant': isConfigVariant() }">
  <pdp-attributes-components-label [attributeGroupName]="labelAttrGroupName()">
  </pdp-attributes-components-label>
  @if (hmfSelectableOptions.length > 1 || !isAlternativeInStockEnabled()) {
    <div
      class="hmf-grid selector-attribute-outer"
			[ngClass]="{
				'overflow-scroll': overflowXScroll(),
				'hmf-display-flex hmf-ml-0 hmf-pl-0': isConfigVariant()
			}">
      @if (!isConfigVariant()) {
        <hmf-selectable
          [options]="hmfSelectableOptions"
          [multipleSelection]="false"
          [allowDeselection]="false"
          [shape]="'square'"
          [variant]="'text'"
          [contained]="true"
          [height]="'41px'"
          [minWidth]="'65px'"
          [spaceBetween]="'--hmf-xs'"
          [fillColor]="'--hmf-gray000'"
          [classList]="'hmf-body-m hmf-flex-nowrap hmf-flex-md-wrap hmf-mr-0'"
          [optionsClassList]="'hmf-body-m'"
          (selectionChange)="handleHmfSelectableChange($event)">
        </hmf-selectable>
      } @else {
        @for (
          attributesOption of selectorAttributeData(); track trackByFn($index,
          attributesOption); let isLast = $last) {
          <hmf-selector
            class="hmf-mr-xs"
            height="42px"
            [ngClass]="{ 'hmf-mb-s': !isLast }"
            [unavailable]="attrUnavailableState[attributesOption.value]"
            [contained]="true"
            [selector]="'rectangular'"
            [circleVariant]="false"
            [dblBorder]="false"
            [width]="'100%'"
            [selected]="attrSelectionState[attributesOption.value]"
            [ariaLabel]="attributesOption.value"
            (click)="selectedAttribute(attributesOption)">
            <ng-container ngProjectAs="rectangularSelectorBody">
              <div
                class="selector-body hmf-display-flex hmf-align-items-center hmf-px-s">
                <span
                  class="hmf-header-xs label-base"
									[ngClass]="{
										'hmf-header-bold-xs':
											attrSelectionState[attributesOption.value] &&
											!attrUnavailableState[attributesOption.value]
									}">
                  {{ attributesOption.value }}
                </span>
              </div>
            </ng-container>
          </hmf-selector>
        }
      }
    </div>
  }

  @if (showPreselectionMessage) {
    <div
      class="hmf-display-flex hmf-flex-row hmf-p-xs hmf-my-m hmf-mx-0 fill-warning-subtle message-content-border"
      >
      <homefield-icon
        width="16px"
        height="16px"
        [name]="'alert-warning-filled'"
        fill="var(--hmf-border-warning)"
        aria-hidden="true">
      </homefield-icon>
      <div class="hmf-ml-xxxs">
        <span class="label-base hmf-subheader-bold-s">{{ preselectionTitleMessage }}</span>
        <p class="label-base hmf-mb-0 hmf-body-s">{{ preselectionDescMessage }}</p>
      </div>
    </div>
  }
</section>
